// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/5140c92f/" + chunkId + "." + __webpack_require__.h() + ".v5140c92f.js";
};